<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="toc">
<h1 class="ctfm"><a class="page" id="pvi"></a><a class="page" id="pvii"></a><a class="page"></a>C<span class="sm">ONTENTS</span></h1>
<p class="tocfm"><a class="xref" href="#/chikrause0007#acknow">A<span class="sm">CKNOWLEDGMENTS</span></a></p>
<p class="toc"><a class="xref" href="#/chikrause0008#intro">I<span class="sm">NTRODUCTION</span> / Reconstructing Liberal Individualism</a></p>
<p class="toc"><a class="xref" href="#/chikrause0009#ch01">O<span class="sm">NE</span> / Non-sovereign Agency</a></p>
<p class="toc"><a class="xref" href="#/chikrause0010#ch02">T<span class="sm">WO</span> / Agency, Inequality, and Responsibility</a></p>
<p class="toc"><a class="xref" href="#/chikrause0011#ch03">T<span class="sm">HREE</span> / Vitalities of Non-sovereign Agency</a></p>
<p class="toc"><a class="xref" href="#/chikrause0012#ch04">F<span class="sm">OUR</span> / What Is Freedom?</a></p>
<p class="toc"><a class="xref" href="#/chikrause0013#ch05">F<span class="sm">IVE</span> / Plural Freedom</a></p>
<p class="toc"><a class="xref" href="#/chikrause0014#concl">C<span class="sm">ONCLUSIONS</span> / Redeeming Freedom</a></p>
<p class="tocbm"><a class="xref" href="#/chikrause0015#notes"><i>Notes</i></a></p>
<p class="tocbm"><a class="xref" href="#/chikrause0016#biblio"><i>Bibliography</i></a></p>
<p class="tocbm"><a class="xref" href="#/chikrause0017#index"><i>Index</i></a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-krause-0006.vue?ca2dfb16